import {Injectable} from "@angular/core";
import {Adapter} from "./adapter";

export class TradingAccounts {

    public GL_ID = null;
    public GL_Code = null;
    public GL_Desc = null;
    public GL_ShortDesc = null;
    public GLGrp_Code = null;
    public RecoGroup = null;
    public CreatedBy = null;
    public CreatedOn = null;
    public ModifiedBy = null;
    public ModifiedOn = null;

    constructor(public initVal: Partial<TradingAccounts>) {
        Object.assign(this, initVal);
    }
}

@Injectable()
export class TradingAccountsAdapter implements Adapter<TradingAccounts> {
    adapt(item: any): TradingAccounts {
        return new TradingAccounts(item);
    }
}